import { useCallback } from "react";

import type { EnrichedJobDetailsPreference } from "../types";
import {
  useResetUserMinimumPayPreferenceMutation,
  useResetUserPreferenceMutation,
} from "./__generated__/useResetPreference.gqlgenerated";

export function useResetPreference() {
  const [resetUserPreferenceMutation] = useResetUserPreferenceMutation();
  const [resetUserMinimumPayPreferenceMutation] = useResetUserMinimumPayPreferenceMutation();

  return useCallback(
    async (preference: EnrichedJobDetailsPreference) => {
      if (!preference.prefIds.length) {
        throw new Error(`No preference ID supplied for preference ${preference.label}`);
      }
      let requestSucceeded: boolean;
      if (preference.salaryInfoModel) {
        const { data } = await resetUserMinimumPayPreferenceMutation({
          variables: { id: preference.prefIds[0] },
        });
        if (!data?.updateJobSeekerProfileStructuredDataPreference) {
          throw new Error(
            `reset preference call returned no data for attribute ${preference.suid}`,
          );
        }
        const savedPreference = data.updateJobSeekerProfileStructuredDataPreference?.preference;
        requestSucceeded = savedPreference?.minimumPay?.amount === 0;
      } else {
        const { data } = await resetUserPreferenceMutation({
          variables: { ids: preference.prefIds },
        });
        if (!data?.deleteJobSeekerProfileStructuredDataPreferenceAttributes) {
          throw new Error(
            `reset preference call returned no data for attribute ${preference.suid}`,
          );
        }
        const { positivePreferenceAttributeIds, dislikedPreferenceAttributeIds } =
          data.deleteJobSeekerProfileStructuredDataPreferenceAttributes;
        requestSucceeded = !!(
          positivePreferenceAttributeIds?.length || dislikedPreferenceAttributeIds?.length
        );
      }

      if (requestSucceeded) {
        return true;
      } else {
        throw new Error("preference was not actually deleted");
      }
    },
    [resetUserPreferenceMutation, resetUserMinimumPayPreferenceMutation],
  );
}
